import React, { createContext, useContext, useEffect, useState } from 'react';
import { api, authHeaders, formatApiErrorDetail } from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('brayo_token'));
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let alive = true;
    if (!token) {
      setChecking(false);
      return;
    }
    api.get('/auth/me', { headers: authHeaders(token) })
      .then(({ data }) => { if (alive) { setUser(data); setChecking(false); } })
      .catch(() => {
        if (!alive) return;
        localStorage.removeItem('brayo_token');
        setToken(null);
        setUser(null);
        setChecking(false);
      });
    return () => { alive = false; };
  }, [token]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post('/auth/login', { email, password });
      localStorage.setItem('brayo_token', data.access_token);
      setToken(data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem('brayo_token');
    setToken(null);
    setUser(null);
    api.post('/auth/logout').catch(() => {});
  };

  return (
    <AuthContext.Provider value={{ token, user, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);